export default __webpack_public_path__ + "static/media/instagram.7951df5d.svg";